export const checkWebp = () => {
  const bodyClassList = document.body.classList;
  return bodyClassList.contains('webp');
};
